import './custom.css'

import { ReactNode } from 'react';
import { Route } from 'react-router';
import { Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import AppLayout from './components/layout/AppLayout';
import Home from './components/Home';
import { Firmware } from './components/Firmware';
import Register from './components/Register';
import Login from './components/Login';
import Settings from './components/Settings';
import ConfirmEmail from './components/ConfirmEmail';
import Downloads from './downloads/Downloads';
import ForgotPassword from './components/ForgotPassword';
import ForgotPasswordConfirmation from './components/ForgotPasswordConfirmation';
import ChangePassword from './components/ChangePassword';
import OnlineDrones from './components/OnlineDrones';
import Users from './components/Users';
import Wiki from './components/wiki/Wiki';
import QuickStart from './components/wiki/QuickStart';
import Ogn from './components/wiki/Ogn';
import Statistic from './components/statistics/Statistic';
import ModemStatistic from './components/statistics/ModemStatistic';
import ModemsStatistic from './components/statistics/ModemsStatistic';
import FirmwareV2 from './components/FirmwareV2';
import Console from "./components/console/Console"
import { AuthLoading, RequireAuth, RedirectIfAuthenticated, useAuth } from './AuthContext';
import { useAccess } from './access/PlatformAccess';

/**
 * Корень разводится по авторизации: гость видит лендинг, залогиненный — консоль.
 * До ответа /api/auth/me ничего не решаем, иначе на секунду мелькал бы лендинг.
 * Шапку обе ветки получают от AppLayout — сами её не рисуют.
 */
function RootRoute(): ReactNode {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return <AuthLoading />;
    }

    return user ? <Console /> : <Home />;
}

export default function App(): ReactNode {
    const access = useAccess();

    return (
        <>
            <Layout>
                {/* Всё под двухэтажной шапкой: первый этаж — навигация,
                    второй экраны наполняют сами через PageBar. */}
                <Route element={<AppLayout />}>
                    <Route path='/' element={<RootRoute />} />
                    <Route path='/downloads' element={<Downloads />} />
                    {/* Старые адреса отдельных страниц: на /mp и /qgc
                        ссылается документация, ломать их нельзя. */}
                    <Route path='/mp' element={<Navigate to='/downloads' replace />} />
                    <Route path='/qgc' element={<Navigate to='/downloads' replace />} />
                    <Route path='/alp' element={<Navigate to='/downloads' replace />} />
                    <Route path='/wiki' element={<Wiki />}>
                        <Route path="quickStart" element={<QuickStart />} />
                        <Route path="ogn" element={<Ogn />} />
                    </Route>
                    <Route path='/confirm-email' element={<ConfirmEmail />} />
                    <Route path='/firmware' element={<RequireAuth><FirmwareV2 /></RequireAuth>} />
                    <Route path='/firmware_old' element={<RequireAuth><Firmware /></RequireAuth>} />
                    <Route path='/settings' element={<RequireAuth><Settings /></RequireAuth>} />
                    <Route path='/account/password' element={<RequireAuth><ChangePassword /></RequireAuth>} />
                    <Route path='/onlineDrones' element={<RequireAuth><OnlineDrones /></RequireAuth>} />
                    <Route path='/users' element={<RequireAuth><Users /></RequireAuth>} />
                    <Route path='/statistics' element={<RequireAuth><Statistic /></RequireAuth>} />
                    <Route path='/statistics/modem' element={<RequireAuth><ModemStatistic /></RequireAuth>} />
                    <Route path='/statistics/modems' element={<RequireAuth><ModemsStatistic /></RequireAuth>} />
                    {/* Экраны модели доступа стенда: у другой модели их нет вовсе. */}
                    {access.routes.map((route) =>
                        <Route key={route.path} path={route.path} element={route.element} />
                    )}

                    {/* Формы входа и восстановления тоже под общей шапкой:
                        иначе с них не выйти никуда, кроме как через ссылки
                        внутри самой формы. */}
                    <Route path='/login' element={<RedirectIfAuthenticated><Login /></RedirectIfAuthenticated>} />
                    <Route path='/registration' element={<Register />} />
                    <Route path='/forgot-pass' element={<ForgotPassword />} />
                    <Route path='/forgot-pass-confirm' element={<ForgotPasswordConfirmation />} />
                </Route>
            </Layout>
        </>
    );
}
